import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
//#region src/hooks/archiveCacheUpdate.ts
var t = [
	"active",
	"inquiries",
	"upcoming",
	"staying",
	"past"
], n = (e) => e[2]?.tab, r = (e, t) => ({
	...e,
	pages: e.pages.map((e) => ({
		...e,
		conversations: t(e.conversations)
	}))
});
function i(t, i, a, o) {
	let s = t.getQueryCache().findAll({ queryKey: e.conversations() }), c = [];
	for (let { queryKey: e } of s) {
		let s = t.getQueryData(e);
		if (c.push([e, s]), !s) continue;
		let l = a(n(e)) ? r(s, (e) => e.filter((e) => e.id !== i)) : r(s, (e) => e.map((e) => e.id === i ? {
			...e,
			archived_at: o
		} : e));
		t.setQueryData(e, l);
	}
	let l = e.conversation(i), u = t.getQueryData(l);
	return u && t.setQueryData(l, { conversation: {
		...u.conversation,
		archived_at: o
	} }), {
		previous: c,
		single: {
			key: l,
			data: u
		}
	};
}
var a = (e, n, r) => i(e, n, (e) => !!e && t.includes(e), r), o = (e, t) => i(e, t, (e) => e === "archived", null);
//#endregion
export { a as applyArchiveOptimistically, o as applyUnarchiveOptimistically };
